import * as React from "react";
import { CouponType } from "../../../../services/banner";
import { getLitbLangFn } from "../../../../utils/language/index";
import Toast from "../../../../components/Toast";
import { LTReceiveToast } from "../../../../components/LTReceiveToast";
const CopyToast = (props) => {
    const { language = "en", handleClose } = props;
    React.useEffect(() => {
        setTimeout(() => {
            handleClose();
        }, 3000);
    }, []);
    return React.createElement(Toast, { message: `${getLitbLangFn("Coupon successfully copied", language)}` });
};
export const CouponToast = (props) => {
    const { type, status, language, handleClose } = props;
    if (type === CouponType.CopyCoupon) {
        return React.createElement(CopyToast, { language: language, handleClose: handleClose });
    }
    return React.createElement(LTReceiveToast, { isMobile: true, status: status, lang: language, onClose: handleClose });
};
